import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { UnlockListingModal } from "@/components/UnlockListingModal";

/**
 * Route wrapper for the paid-unlock checkout (`/listings/:id/unlock`).
 *
 * The checkout itself is a popup — the marketplace opens it in place — so this
 * page exists only for direct links/bookmarks and just renders the same modal.
 * Dismissing it goes back to wherever the buyer came from.
 */
export default function UnlockPaymentPage() {
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    navigate("/sign-in");
    return null;
  }
  if (!id) return null;

  return (
    <UnlockListingModal
      listingId={id}
      onClose={() => navigate(-1)}
      onUnlocked={(listingId) => navigate(`/listings/${listingId}`)}
    />
  );
}
